import { Box, Skeleton } from '@mui/material'

export const Loader = () => {
    return (
        <Box width="100%" display="flex" flexDirection="column">
            <Box my="32px">
                <Skeleton variant="rounded" sx={{ height: 50, width: '80%', background: '#EAEEF5' }} />
            </Box>
            <Box display="flex" alignItems="center" gap="24px"  width="100%">
                <Box display="flex" alignItems="center" gap="16px"  width="100%">
                    <Skeleton variant="circular" width={40} height={40} sx={{bgcolor:"#EAEEF5"}} />
                    <Box display="flex" flexDirection="column" gap="2px" width="100%">
                        <Skeleton variant="text" sx={{ fontSize: '14px', width: '30%', background: '#EAEEF5' }} />
                        <Skeleton variant="text" sx={{ fontSize: '12px', width: '15%', background: '#EAEEF5' }} />
                    </Box>
                </Box>
            </Box>  
            <Box width="100%" height="100%" minHeight="376px" my="24px">
                <Skeleton variant="rounded" sx={{ height: 376, width: '100%', background: '#EAEEF5' }} />
            </Box>     
            <Box width="100%" display="flex" flexDirection="column" >
                <Skeleton variant="text" sx={{ fontSize: '16px', width: '100%', background: '#EAEEF5' }} />
                <Skeleton variant="text" sx={{ fontSize: '16px', width: '80%', background: '#EAEEF5' }} />
                <Skeleton variant="text" sx={{ fontSize: '16px', width: '60%', background: '#EAEEF5' }} />
            </Box>
        </Box>
    )
}
